import React from "react";
import { Box, FormDialog, ImageList, Typography } from "flux";
import { BaseDialogProps } from "@adora/shared/contexts/dialog-context";
import { Image } from "@adora/shared/types/image";
import useAdAssetAdImageResizes from "../../hooks/use-ad-image-resizes";

interface ResizedImagesDialogProps extends BaseDialogProps {
  adAssetGroupId: number;
  image: Image;
  brandId: number;
}

const ResizedImagesDialog: React.FC<ResizedImagesDialogProps> = ({ adAssetGroupId, image, brandId, open, onClose }) => {
  const { images, isLoading } = useAdAssetAdImageResizes(adAssetGroupId, image.id.toString(), brandId.toString());

  const ImagePreviewCell: React.FC<{ image?: Image }> = ({ image }) => {
    if (!image) return <Typography color="textSecondary">No image</Typography>;
    return (
      <a href={image.src} target="_blank" rel="noopener noreferrer" aria-label="Open image in a new tab">
        <div>
          <img key={image.id} src={image.src} alt="Preview" width={150} height={150} style={{ objectFit: "contain" }} />
        </div>
        <div>
          <Typography variant="caption" color="textSecondary">
            {image.id}
          </Typography>
        </div>
      </a>
    );
  };

  return (
    !isLoading && (
      <FormDialog
        title="Resized Images"
        description={"All Previously Resized Images"}
        open={open}
        onClose={onClose}
        onSubmit={async () => {
          onClose(true);
        }}
        primaryButtonText="Close"
        isPrimaryButtonDisabled={false}
        dataDogIdentifier="resized images"
      >
        <ImageList itemWidth={180} columnCount={5} gap={8}>
          {images.length > 0 &&
            images.map((image) => (
              <Box key={image.id}>
                <ImagePreviewCell image={image} />
              </Box>
            ))}
        </ImageList>
      </FormDialog>
    )
  );
};

export default ResizedImagesDialog;
